import type { components } from "@qorakul/shared/api";

export type Role = components["schemas"]["Role"];

/** Fixed roles in the order they are offered; labels come from the "roles" i18n namespace. */
export const allRoles: readonly Role[] = [
  "SuperAdmin",
  "Director",
  "DeputyDirector",
  "Administrator",
  "Accountant",
  "Teacher",
  "DormitorySupervisor",
  "KitchenManager",
  "Parent",
];

export const roleTagColor: Record<Role, string> = {
  SuperAdmin: "volcano",
  Director: "gold",
  DeputyDirector: "orange",
  Administrator: "blue",
  Accountant: "green",
  Teacher: "cyan",
  Parent: "default",
  DormitorySupervisor: "purple",
  KitchenManager: "magenta",
};
